<footer class="flex-none">
	<!-- <img class="max-w-screen-content w-full px-5" src="/images/footer-image.png" alt="footerImage" /> -->

	<div class="min-h-[330px] md:min-h-[200px] bg-affair p-10 w-full">
		<div
			class="max-w-screen-content flex flex-col md:flex-row items-center justify-between m-auto px-0 md:px-5 gap-3 md:gap-0"
		>
			<img class="h-[60px]" src="/images/white-logo.png" alt="logo" />
			<!-- <div class="flex flex-row md:flex-col gap-4 footer-menu-item">
				<p>About Us</p>
				<p>Contact Us</p>
				<p>Register Now!</p>
			</div> -->
			<div class="flex flex-col gap-3 items-center">
				<p class="text-2xl font-jakarta-bold text-[#F4F5F5]">Join our malling list</p>
				<div class="flex gap-3">
					<a
						target="_blank"
						href="https://www.instagram.com/chessat3/"
						class="h-10 w-10 bg-white rounded-full grid place-content-center cursor-pointer"
					>
						<img class="w-8" src="/icons/instagram.svg" alt="instagram" />
					</a>
					<a
						target="_blank"
						href="https://www.facebook.com/ChessatThree/"
						class="h-10 w-10 bg-white rounded-full grid place-content-center cursor-pointer"
					>
						<img class="w-6" src="/icons/facebook.svg" alt="facebook" />
					</a>
					<a
						target="_blank"
						href="https://www.tiktok.com/@chessat3"
						class="h-10 w-10 bg-white rounded-full grid place-content-center cursor-pointer"
					>
						<img class="w-7" src="/icons/tiktok.svg" alt="twitter" />
					</a>
					<a
						target="_blank"
						href="https://www.linkedin.com/company/chess-at-three/"
						class="h-10 w-10 bg-white rounded-full grid place-content-center cursor-pointer"
					>
						<img class="w-8" src="/icons/linkedin.svg" alt="linkedin" />
					</a>
				</div>
			</div>
		</div>
	</div>
</footer>
